import defs from '../../_core/defs.js';
import processPush from './processpush.js';
import processUnshift from './processunshift.js';
import processRecreate from './processrecreate.js';
import processSort from './processsort.js';
import processRemove from './processremove.js';
import processRerender from './processrerender.js';
import processSpliceAdd from './processspliceadd.js';
// the containers an array has rendered into: a forced rerender takes old nodes out of these, and leaves a node
// the user moved elsewhere
export function addContainer(selfDef, container) {
  var _selfDef$containers;
  (_selfDef$containers = selfDef.containers) != null ? _selfDef$containers : selfDef.containers = new WeakMap();
  selfDef.containers.set(container, true);
}
// makes possible to render array items based on a name of called method
export default function processRendering(_ref) {
  var self = _ref.self,
    eventOptions = _ref.eventOptions;
  var method = eventOptions.method,
    added = eventOptions.added,
    removed = eventOptions.removed;
  // nodes object always exist at Matreshka instances
  var container = self.nodes.container || self.nodes.sandbox;
  var selfDef = defs.get(self);
  if (!container) {
    return;
  }
  addContainer(selfDef, container);
  switch (method) {
    case 'push':
      processPush({
        self: self,
        selfDef: selfDef,
        eventOptions: eventOptions,
        container: container
      });
      break;
    case 'unshift':
      processUnshift({
        self: self,
        selfDef: selfDef,
        eventOptions: eventOptions,
        container: container
      });
      break;
    case 'pull':
    case 'pop':
    case 'shift':
      processRemove({
        self: self,
        selfDef: selfDef,
        eventOptions: eventOptions,
        container: container
      });
      break;
    case 'sort':
    case 'reverse':
      processSort({
        self: self,
        selfDef: selfDef,
        eventOptions: eventOptions,
        container: container
      });
      break;
    case 'rerender':
      processRerender({
        self: self,
        selfDef: selfDef,
        eventOptions: eventOptions,
        container: container
      });
      break;
    case 'recreate':
      processRecreate({
        self: self,
        selfDef: selfDef,
        eventOptions: eventOptions,
        container: container
      });
      break;
    case 'splice':
      if (added.length) {
        processSpliceAdd({
          self: self,
          selfDef: selfDef,
          eventOptions: eventOptions,
          container: container
        });
      }
      if (removed.length) {
        processRemove({
          self: self,
          selfDef: selfDef,
          eventOptions: eventOptions,
          container: container
        });
      }
      break;
  }
}